export default input => {
  input.indeterminate = true
}